export enum NivelAcessoEnum {
    admin = "0",
    gerente = "1",
    usuario = "2"
}